var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('file-manager',{attrs:{"mode":_vm.mode,"settings":{folderBack: _vm.folderBack, startFolder: _vm.startFolder, startSelection: _vm.startSelection, startDisk: _vm.startDisk}},on:{"select":_vm.select}})}
var staticRenderFns = []

export { render, staticRenderFns }